import { Button } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { isAfter } from 'date-fns';
import { ReferralListDto, ReferrerInfoDto } from '../../../../api/tor-api';

type Props = {
    referralInfo: ReferrerInfoDto | null;
    referrals: ReferralListDto;
    loading: boolean;
    hasMore: boolean;
    onLoadMore: () => void;
    onClaim: VoidFunction;
};

export const RefList: React.FC<Props> = ({
    referralInfo,
    referrals,
    loading,
    hasMore,
    onLoadMore,
    onClaim,
}) => {
    const handleScroll = useCallback(
        (event: React.UIEvent<HTMLDivElement>) => {
            const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
            if (scrollHeight - scrollTop <= clientHeight * 1.5 && !loading && hasMore) {
                onLoadMore();
            }
        },
        [loading, hasMore, onLoadMore],
    );

    console.log(referralInfo);

    const renderClaimState = useMemo(() => {
        if (
            !referralInfo?.nextAvailableClaimDate ||
            isAfter(new Date(), new Date(referralInfo?.nextAvailableClaimDate || ''))
        ) {
            return (
                <>
                    <Button
                        onClick={onClaim}
                        type="primary"
                        disabled={!referralInfo?.availableRefClaim}
                        className="!text-black w-auto !text-[17px] !font-mono !py-2 !px-6 h-[40px] !font-medium disabled:!text-white"
                    >
                        <div className="flex items-center justify-center gap-2">
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g clipPath="url(#clip0_2482_2371)">
                                    <path
                                        d="M12.6098 7.13369C12.5996 6.22707 13.7144 7.02235 14.9885 6.34901C17.1564 5.20115 16.0442 1.24063 13.2392 2.25064C11.0301 3.04593 11.6209 6.24562 10.5292 6.182C8.95457 6.08922 9.38097 2.16846 5.39948 1.74431C3.1981 1.51103 1.66715 3.1175 1.90347 4.88834C2.20915 7.18936 4.7984 6.80232 4.79326 7.84415C4.78556 8.9708 1.13029 8.58376 0.544625 11.9478C-0.110395 15.7175 6.63246 17.7693 8.50248 15.0441C9.05989 14.2329 9.10612 12.9896 7.8603 12.1572C6.45008 11.2162 5.13233 8.98671 6.53228 7.13104C7.12565 6.34636 8.65146 6.52662 8.99824 7.56315C9.36299 8.65003 8.51532 9.06093 8.21478 9.72632C7.78581 10.6091 8.32267 11.5184 9.24226 11.6191C10.0488 11.7066 10.5009 11.2586 10.5343 10.6913C10.5908 9.72632 9.99489 9.74223 10.2132 8.99466C10.578 7.74341 13.2392 8.52279 12.5919 10.967C12.2528 12.2447 10.709 12.2288 10.6705 13.8618C10.6268 15.7493 12.3427 16.1655 13.7837 16.131C16.319 16.07 17.814 14.3363 17.4441 11.2559C16.9381 7.06212 12.6227 8.30541 12.6098 7.13369Z"
                                        fill={
                                            !referralInfo?.availableRefClaim ? 'white' : '#050505'
                                        }
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_2482_2371">
                                        <rect
                                            width="17"
                                            height="17"
                                            fill="white"
                                            transform="translate(0.5 0.5)"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                            Claim
                        </div>
                    </Button>
                    <span className="font-druk text-[24px] font-bold leading-8 text-[#E6E6E6]">
                        {referralInfo?.availableRefClaim
                            ? parseFloat(referralInfo?.availableRefClaim?.toFixed(2))
                            : 0}
                    </span>
                </>
            );
        }

        return (
            <>
                <div className="rounded-full border border-[#2B2B2B] w-10 h-10 flex items-center justify-center">
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clipPath="url(#clip0_2471_9996)">
                            <path
                                d="M20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 9.77899 0.0877974 9.56702 0.244078 9.41074C0.400358 9.25446 0.61232 9.16667 0.833333 9.16667C1.05435 9.16667 1.26631 9.25446 1.42259 9.41074C1.57887 9.56702 1.66667 9.77899 1.66667 10C1.66667 11.6482 2.15541 13.2593 3.07109 14.6298C3.98676 16.0002 5.28825 17.0683 6.81097 17.699C8.33369 18.3297 10.0092 18.4948 11.6258 18.1732C13.2423 17.8517 14.7271 17.058 15.8926 15.8926C17.058 14.7271 17.8517 13.2423 18.1732 11.6258C18.4948 10.0092 18.3297 8.33369 17.699 6.81097C17.0683 5.28825 16.0002 3.98676 14.6298 3.07109C13.2593 2.15541 11.6482 1.66667 10 1.66667C9.77899 1.66667 9.56702 1.57887 9.41074 1.42259C9.25446 1.26631 9.16667 1.05435 9.16667 0.833333C9.16667 0.61232 9.25446 0.400358 9.41074 0.244078C9.56702 0.0877974 9.77899 0 10 0C12.6513 0.00286757 15.1932 1.05736 17.0679 2.9321C18.9426 4.80684 19.9971 7.34872 20 10ZM8.56417 9.16667H6.66667C6.44565 9.16667 6.23369 9.25446 6.07741 9.41074C5.92113 9.56702 5.83333 9.77899 5.83333 10C5.83333 10.221 5.92113 10.433 6.07741 10.5893C6.23369 10.7455 6.44565 10.8333 6.66667 10.8333H8.56417C8.69143 11.0544 8.86786 11.2431 9.0798 11.385C9.29173 11.5269 9.53349 11.6181 9.78633 11.6515C10.0392 11.6849 10.2963 11.6597 10.5378 11.5778C10.7794 11.4959 10.9988 11.3595 11.1792 11.1792C11.3595 10.9988 11.4959 10.7794 11.5778 10.5378C11.6597 10.2963 11.6849 10.0392 11.6515 9.78633C11.6181 9.53349 11.5269 9.29173 11.385 9.0798C11.2431 8.86786 11.0544 8.69143 10.8333 8.56417V5.83333C10.8333 5.61232 10.7455 5.40036 10.5893 5.24408C10.433 5.0878 10.221 5 10 5C9.77899 5 9.56702 5.0878 9.41074 5.24408C9.25446 5.40036 9.16667 5.61232 9.16667 5.83333V8.56417C8.91702 8.7094 8.7094 8.91702 8.56417 9.16667ZM1.5225 7.32C1.68732 7.32 1.84843 7.27113 1.98548 7.17956C2.12252 7.08799 2.22933 6.95784 2.2924 6.80557C2.35547 6.6533 2.37198 6.48574 2.33982 6.32409C2.30767 6.16244 2.2283 6.01395 2.11176 5.89741C1.99521 5.78087 1.84673 5.7015 1.68508 5.66935C1.52342 5.63719 1.35587 5.65369 1.2036 5.71677C1.05133 5.77984 0.921176 5.88665 0.829609 6.02369C0.738041 6.16073 0.689167 6.32185 0.689167 6.48667C0.689167 6.70768 0.776964 6.91964 0.933244 7.07592C1.08952 7.2322 1.30149 7.32 1.5225 7.32ZM3.5175 4.33917C3.68232 4.33917 3.84343 4.29029 3.98048 4.19872C4.11752 4.10716 4.22433 3.97701 4.2874 3.82474C4.35047 3.67246 4.36698 3.50491 4.33482 3.34326C4.30267 3.18161 4.2233 3.03312 4.10676 2.91658C3.99021 2.80003 3.84173 2.72067 3.68008 2.68851C3.51842 2.65636 3.35087 2.67286 3.1986 2.73593C3.04633 2.79901 2.91618 2.90582 2.82461 3.04286C2.73304 3.1799 2.68417 3.34102 2.68417 3.50583C2.68417 3.72685 2.77196 3.93881 2.92824 4.09509C3.08452 4.25137 3.29649 4.33917 3.5175 4.33917ZM6.4825 2.3675C6.64732 2.3675 6.80843 2.31863 6.94547 2.22706C7.08252 2.13549 7.18933 2.00534 7.2524 1.85307C7.31547 1.7008 7.33198 1.53324 7.29982 1.37159C7.26767 1.20994 7.1883 1.06145 7.07176 0.944911C6.95521 0.828367 6.80673 0.749 6.64507 0.716846C6.48342 0.684691 6.31587 0.701194 6.1636 0.764267C6.01133 0.82734 5.88118 0.93415 5.78961 1.07119C5.69804 1.20823 5.64917 1.36935 5.64917 1.53417C5.64917 1.75518 5.73696 1.96714 5.89324 2.12342C6.04952 2.2797 6.26149 2.3675 6.4825 2.3675Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_2471_9996">
                                <rect width="20" height="20" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div className="flex flex-col gap-2">
                    <p className="font-mono text-[14px] text-[#E6E6E6]">Calculating</p>
                    <p className="font-mono text-[14px] text-[#E6E6E6] text-center">...</p>
                </div>
            </>
        );

        // eslint-disable-next-line
    }, [referralInfo, onClaim, referralInfo?.nextAvailableClaimDate]);

    return (
        <div className="flex flex-col h-full">
            <div className="flex w-full p-4">
                <span className="font-mono text-[13px] text-[#808080]">
                    Earn 10% from your friends’ farming. Plus an additional 2.5% from their friends.
                </span>
            </div>
            <div className="flex flex-col p-4 bg-[#000] items-center justify-between border-[2px] border-[#2B2B2B] mb-4 rounded-[8px] gap-3">
                {renderClaimState}
            </div>
            <div
                onScroll={handleScroll}
                className="flex flex-grow flex-col mt-2 -mx-4 overflow-y-scroll max-h-[calc(100vh-370px)] pb-[86px]"
            >
                {referrals?.result?.map((user, index) => (
                    <div
                        key={index}
                        className="flex py-1 border-[#2B2B2B] border-b px-4 justify-between items-center py-1.5"
                    >
                        <div className="flex gap-3">
                            <img
                                src={user?.avatarUrl || '/assets/frien_default.png'}
                                alt="frien_default"
                                className="h-9 w-9 rounded-full"
                            />
                            <div className="flex flex-col">
                                <span className="text-[15px] font-mono font-bold text-[#E6E6E6]">
                                    {user.username ?? user.name}
                                </span>
                                <span className="text-[11px] font-mono text-[#B3B3B3]">
                                    Invited {user.totalReferrals} friends
                                </span>
                            </div>
                        </div>
                        <span className="text-sm font-mono font-bold text-[#E6E6E6]">
                            {parseFloat(user.balance?.toFixed(2))} MTGN
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};
